<mat-card>
  <h2>{{ category.title }}</h2>
  <p translate>{{ category.description }}</p>
  <mat-card-content>
    <div
      fxFlex
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      fxLayoutAlign.lt-sm="center center"
      fxLayoutGap="16px"
      class="category__container"
      *ngIf="tutorialList.length > 0; else tutorialListEmpty"
    >
      <scf-pills-tutorial-video
        fxFlex.lt-sm="1 1 100%"
        *ngFor="let element of tutorialList"
        [data]="element"
        [category]="category.name"
      >
      </scf-pills-tutorial-video>
    </div>
    <ng-template #tutorialListEmpty>
      <div class="card__content--empty">
        <p translate>training.pills.tutorials.empty</p>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
